import { useContext, useEffect, useState } from "react"
import useSound from "use-sound"
import portalSFX from "../lib/audio/portal-switch.mp3"
import jackpotStartSFX from "../lib/audio/light-speed-activated.mp3"
import beforePortalSFX from "../lib/audio/hyperdrive.mp3"
import blackHoleSFX from "../lib/audio/black-hole-appear.mp3"
import lightSpeedSFX from "../lib/audio/light-speed-background-sound.mp3"
import { AppContext } from "../context/createContext"
import { handleJackpotBackgroundSFX } from "./playJackpotBackground"
import useJackpotSoundshelper from "./useJackpotSoundsHelper"

const useJackpotSounds = (
  isLoading: boolean,
  isError: boolean,
  errorText: string,
) => {
  let fadeInterval: any

  const [disableSound, setDisableSound] = useState<boolean>(false)
  const [disableMusic, setDisableMusic] = useState<boolean>(false)
  const [lightSpeedPlayed, setLightSpeedPlayed] = useState<boolean>(false)
  const [hiperDrivePlayed, setHiperDrivePlayed] = useState<boolean>(false)
  const [portalPlayed, setPortalPlayed] = useState<boolean>(false)

  const [jackpotWinner, setjackpotWinner] = useState<boolean>(false)

  const {
    audio: { music, isMusicOff, isSoundOff, sound },
    jackpotState,
    // jackpotInfo,
  } = useContext(AppContext)

  const [vol, setVolume] = useState(parseFloat(sound) / 100)

  const [playPortalSFX, { stop: stopPortal }] = useSound(portalSFX, {
    volume: parseFloat(sound) / 100,
  })

  // const [playJackpotWinnerSFX, { stop: stopJackpotWinner }] = useSound(
  //   jackpotWinnerSFX,
  //   {
  //     volume: parseFloat(sound) / 100,
  //   },
  // )
  const [playBeforePortalSFX, { stop: stopBeforePortal }] = useSound(
    beforePortalSFX,
    {
      volume: parseFloat(sound) / 100,
    },
  )
  const [playJackpotStartSFX, { stop: stopJackpotStart }] = useSound(
    jackpotStartSFX,
    {
      volume: parseFloat(sound) / 100,
    },
  )
  const [playBlackHoleSFX, { stop: stopBlackHole }] = useSound(blackHoleSFX, {
    volume: parseFloat(sound) / 100,
  })
  const [playLightSpeedSFX, { stop: stopLightSpeed }] = useSound(
    lightSpeedSFX,
    {
      volume: vol,
    },
  )
  const { soundStates, backgroundState } = useJackpotSoundshelper()


  //reset sounds if second jackpot appears
  useEffect(() => {
    if (jackpotState.state === "finished") {
      lightSpeedPlayed && setLightSpeedPlayed(false)
      portalPlayed && setPortalPlayed(false)
      hiperDrivePlayed && setHiperDrivePlayed(false)
    }
  }, [jackpotState.state, portalPlayed, hiperDrivePlayed, lightSpeedPlayed])

  //disable sounds and music on error and loader
  useEffect(() => {
    if (isError && errorText !== "" && isLoading) {
      setDisableSound(true)
      setDisableMusic(true)
    }
  }, [isError, errorText, isLoading])

  //play one time sounds
  useEffect(() => {
    if (!isSoundOff && !disableSound) {
      if (soundStates === "lightSpeed") {
        !lightSpeedPlayed && playJackpotStartSFX()
        setLightSpeedPlayed(true)
      }
      if (soundStates === "hyperdrive") {
        !hiperDrivePlayed && playBeforePortalSFX()
        setHiperDrivePlayed(true)
      }
      if (soundStates === "portal") {
        !portalPlayed && playPortalSFX()
        setPortalPlayed(true)
      }
    } else {
      stopBeforePortal()
      stopJackpotStart()
      stopPortal()
    }
  }, [
    isSoundOff,
    soundStates,
    lightSpeedPlayed,
    hiperDrivePlayed,
    portalPlayed,
  ])

  //here comes background sounds
  handleJackpotBackgroundSFX(
    isMusicOff,
    music,
    isError,
    isLoading,
    jackpotState.state,
    disableMusic,
    errorText,
  )

  useEffect(() => {
    if (!isSoundOff && !disableSound) {
      if (backgroundState === "lightSpeed") {
        playLightSpeedSFX()
      }
    } else {
      stopLightSpeed()
    }
    return () => stopLightSpeed()
  }, [backgroundState, isSoundOff, disableSound])

  useEffect(() => {
    let timeout: any
    if (!isSoundOff && !disableSound) {
      if (jackpotState.state === "initBlackHole") {
        fadeInterval = setInterval(function () {
          if (vol <= 0) {
            clearInterval(fadeInterval)
            stopLightSpeed()
            return
          }
          setVolume(vol - 0.1)
        }, 200)
        setTimeout(() => {
          playBlackHoleSFX()
        }, 500)
      }
    } else {
      stopBlackHole()
      stopLightSpeed()
    }

    return () => clearTimeout(timeout)
  }, [jackpotState.state, isSoundOff, disableSound])
}

export default useJackpotSounds
